export default {
  LIFF_URL: process.env.REACT_APP_LIFF_URL,
  API_URL: process.env.REACT_APP_API_URL,
  API_URL_UAT: process.env.REACT_APP_API_URL_UAT,
  S3_URL: process.env.REACT_APP_S3_URL,
  PORT: process.env.PORT,
  AVATAR_DEFAULT:
    'https://obs.line-scdn.net/0hytw49WslJltKTQmaOhZZDHQQLTl5LzhQaCg9PjoYeD5uKmZaJis8ODwjeGM1KmkMcC0sPGgZeztlKjM',
  AVATAR_DEFAULT2:
    'https://images.unsplash.com/photo-1616740794225-63e524d43ec7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2795&q=80',
  SHARE_URL: process.env.REACT_APP_SHARE_URL,
  AWS_ACCESS_KEY: process.env.REACT_APP_AWS_ACCESS_KEY,
  AWS_SECRET_KEY: process.env.REACT_APP_AWS_SECRET_KEY,
  AWS_REGION: process.env.REACT_APP_AWS_REGION,
  AWS_BUCKET: process.env.REACT_APP_AWS_S3_BUCKET,
  ENVIRONMENT: process.env.ENV_VAR,
  CHALLENGE_API_URL: 'https://t92qrdxvx4.execute-api.ap-southeast-1.amazonaws.com/v2/external',
  CHALLENGE_QUIZ_API_URL: 'https://t92qrdxvx4.execute-api.ap-southeast-1.amazonaws.com/v2/job-management',
  CMS_URL: process.env.REACT_APP_S3_URL_ASSESMENT,
  NGC_SF_URL: process.env.REACT_APP_NGC_STOREFRONT_URL,
  GLUU_IDP_URL: process.env.REACT_APP_GLUU_IDP_URL,
  GLUU_IDP_NONCE: process.env.REACT_APP_GLUU_IDP_NONCE,
  NGC_CLIENTID: process.env.REACT_APP_NGC_CLIENTID,
  NGC_REDIRECT_URI: process.env.REACT_APP_NGC_REDIRECT_URI,
  SMARTDASHBOARD_REDIRECT_URI: process.env.REACT_APP_SMARTDASHBOARD_REDIRECT_URI,
  SMARTDASHBOARD_CLIENTID: process.env.REACT_APP_SMARTDASHBOARD_CLIENTID,
  SMARTDASHBOARD_URL: process.env.REACT_APP_SMARTDASHBOARD_URL,
  PRIVILEGE_REDIRECT_URI: process.env.REACT_APP_PRIVILEGE_REDIRECT_URI,
  PRIVILEGE_CLIENTID: process.env.REACT_APP_PRIVILEGE_CLIENTID,
};
